
/* istanbul ignore file */
import Vue from 'vue';
import Card from '../components/cards/Card.vue';
import { Logo } from '@descomplica/vue-components';
import { getPaddedDisplayNumber } from '@/helpers/string';

interface Data {
  days: Array<String>;
  months: Object;
  currentStep: number;
  selectedDate: string;
  selectedHour: string;
  selectedCampusName: string;
  selectedActivityName: string;
  userPcSrc: string;
  evaluationSrc: string;
  workSrc: string;
  meetingSrc: string;
  currentDate: Date;
}

const days = ['SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB', 'DOM'];
const months = {
  0: 'Janeiro',
  1: 'Fevereiro',
  2: 'Março',
  3: 'Abril',
  4: 'Maio',
  5: 'Junho',
  6: 'Julho',
  7: 'Agosto',
  8: 'Setembro',
  9: 'Outubro',
  10: 'Novembro',
  11: 'Dezembro',
};

export default Vue.extend({
  components: {
    Card,
    Logo,
  },
  data(): Data {
    return {
      days,
      months,
      currentStep: 0,
      selectedDate: '',
      selectedHour: '',
      selectedCampusName: '',
      selectedActivityName: '',
      userPcSrc: `${process.env.BASE_URL}img/user-pc.svg`,
      evaluationSrc: `${process.env.BASE_URL}img/window-select.svg`,
      workSrc: `${process.env.BASE_URL}img/work.svg`,
      meetingSrc: `${process.env.BASE_URL}img/meeting.svg`,
      currentDate: new Date(),
    };
  },
  methods: {
    selectActivity(activityName: string): void {
      this.selectedActivityName = activityName;
      this.goToNextStep();
    },
    selectCampus(campusName: string): void {
      this.selectedCampusName = campusName;
      this.goToNextStep();
    },
    selectDate(day: number, month: number): void {
      this.selectedDate = `${getPaddedDisplayNumber(day)}/${getPaddedDisplayNumber(
        month + 1,
      )}/2019`;
      this.goToNextStep();
    },
    selectHour(hour: string): void {
      this.selectedHour = hour;
      this.goToNextStep();
    },
    goToNextStep(): void {
      this.currentStep += 1;
    },
    goToStep(step: number): void {
      this.currentStep = step;
    },
    getFirstDayInMonth(month: number) {
      return new Date(this.currentDate.getFullYear(), month + 1, 1);
    },
    getDaysInMonth(month: number) {
      return new Date(this.currentDate.getFullYear(), month + 1, 0).getDate();
    },
    getHours() {
      return [
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00',
        '18:30',
        '19:00',
        '19:30',
        '20:00',
        '20:30',
        '21:00',
        '21:30',
      ];
    },
  },
});
